import { ReactNode } from 'react';
import Spinner from '../Spinner';
import TableEmptyState from '../TableEmptyState/TableEmptyState';

const AsyncDisplay = ({
  children,
  isSettled,
  hasData,
}: {
  children: ReactNode;
  isSettled: boolean;
  hasData: boolean;
}) => {
  if (!isSettled) {
    return <Spinner />;
  }

  if (!hasData) {
    return <TableEmptyState />;
  }

  return children;
};

export default AsyncDisplay;
